import React from 'react';

/* ── SVG Icons ── */
const Icon = {
  File: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
    </svg>
  ),
  Mail: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/>
    </svg>
  ),
  Phone: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 012 2a2 2 0 011.72-2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
    </svg>
  ),
  Linkedin: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/>
    </svg>
  ),
  Github: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/>
    </svg>
  ),
  Award: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
    </svg>
  ),
  Sun: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
    </svg>
  ),
  Moon: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
    </svg>
  ),
  X: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  ExternalLink: () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
    </svg>
  ),
  MapPin: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  ),
  Briefcase: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/><line x1="12" y1="12" x2="12" y2="12"/>
    </svg>
  ),
  Terminal: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="4 17 10 11 4 5"/><line x1="12" y1="19" x2="20" y2="19"/>
    </svg>
  ),
};

/* ── Data ── */
const QUICK_STATS = [
  { val: '7mo+',  label: 'Experience' },
  { val: '10K+',  label: 'Users served' },
  { val: '8+',    label: 'Apps shipped' },
  { val: '3',     label: 'Research papers' },
];

const CDN = 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons';

const TECH_STACK = {
  Frontend:  [
    { name: 'React',        src: `${CDN}/react/react-original.svg` },
    { name: 'TypeScript',   src: `${CDN}/typescript/typescript-original.svg` },
    { name: 'Tailwind',     src: `${CDN}/tailwindcss/tailwindcss-original.svg` },
    { name: 'Redux',        src: `${CDN}/redux/redux-original.svg` },
    { name: 'Vite',         src: `${CDN}/vitejs/vitejs-original.svg` },
  ],
  Backend:   [
    { name: 'Node.js',      src: `${CDN}/nodejs/nodejs-original.svg` },
    { name: 'Express',      src: `${CDN}/express/express-original.svg`, invert: true },
    { name: 'Java 17',      src: `${CDN}/java/java-original.svg` },
    { name: 'Spring Boot',  src: `${CDN}/spring/spring-original.svg` },
    { name: 'Docker',       src: `${CDN}/docker/docker-original.svg` },
  ],
  Database:  [
    { name: 'MySQL 8',      src: `${CDN}/mysql/mysql-original.svg` },
    { name: 'MongoDB',      src: `${CDN}/mongodb/mongodb-original.svg` },
    { name: 'Firebase',     src: `${CDN}/firebase/firebase-plain.svg` },
    { name: 'Supabase',     src: `${CDN}/supabase/supabase-original.svg` },
  ],
  'AI / ML': [
    { name: 'TensorFlow',   src: `${CDN}/tensorflow/tensorflow-original.svg` },
    { name: 'OpenCV',       src: `${CDN}/opencv/opencv-original.svg` },
    { name: 'Python',       src: `${CDN}/python/python-original.svg` },
    { name: 'Flask',        src: `${CDN}/flask/flask-original.svg`, invert: true },
    { name: 'Groq API',     fallback: { bg: '#111', text: 'GQ', color: '#fff' } },
  ],
  DevOps:    [
    { name: 'Git',          src: `${CDN}/git/git-original.svg` },
    { name: 'GitHub',       src: `${CDN}/github/github-original.svg`, invert: true },
    { name: 'Postman',      src: `${CDN}/postman/postman-original.svg` },
    { name: 'Netlify',      src: `${CDN}/netlify/netlify-original.svg` },
    { name: 'Vercel',       fallback: { bg: '#000', text: '▲', color: '#fff' } },
  ],
};

const CREDENTIALS = [
  { label: 'Currently',         value: 'Full Stack Dev Intern- Royals Webtech' },
  { label: 'Availability',      value: 'Immediate joiner · Open to relocate' },
  { label: 'Location',          value: 'Nagpur, India' },
  { label: 'Education',         value: 'B.Tech AI- GH Raisoni, 2026 · CGPA 8.46' },
  { label: 'GATE 2026 DS&AI',   value: 'AIR 12,757' },
  { label: 'GATE 2026 CS&IT',   value: 'Qualified' },
  { label: 'GOI Copyright',     value: 'Reg. L-151429/2024' },
];

function Row({ label, value }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, padding: '8px 0', borderBottom: '1px solid var(--border-color)' }}>
      <span style={{ fontFamily: 'var(--mono)', fontSize: 8, letterSpacing: '0.5px', color: 'var(--text-muted)', textTransform: 'uppercase', flexShrink: 0, paddingTop: 1 }}>{label}</span>
      <span style={{ fontFamily: 'var(--mono)', fontSize: 8.5, color: 'var(--text-primary)', textAlign: 'right', lineHeight: 1.5 }}>{value}</span>
    </div>
  );
}

function Divider({ label }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{ flex: 1, height: 1, background: 'var(--border-color)' }} />
      {label && <span style={{ fontFamily: 'var(--mono)', fontSize: 7.5, letterSpacing: '2px', color: 'var(--text-muted)', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{label}</span>}
      <div style={{ flex: 1, height: 1, background: 'var(--border-color)' }} />
    </div>
  );
}

function Btn({ href, onClick, icon: I, label, primary, newTab }) {
  const base = {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    gap: 8, padding: '9px 13px', borderRadius: 3, width: '100%',
    fontFamily: 'var(--mono)', fontSize: 8.5, letterSpacing: '1.5px',
    textTransform: 'uppercase', textDecoration: 'none',
    cursor: 'pointer', transition: 'all 0.2s', border: '1px solid',
    fontWeight: 700,
  };
  const style = primary
    ? { ...base, background: 'var(--accent-color)', color: 'var(--bg)', borderColor: 'var(--accent-color)' }
    : { ...base, background: 'transparent', color: 'var(--text-primary)', borderColor: 'var(--border-color)' };

  const enter = e => {
    if (primary) { e.currentTarget.style.filter = 'brightness(1.1)'; e.currentTarget.style.transform = 'translateY(-1px)'; }
    else { e.currentTarget.style.borderColor = 'var(--accent-color)'; e.currentTarget.style.color = 'var(--accent-color)'; e.currentTarget.style.background = 'var(--accent-glow)'; }
  };
  const leave = e => {
    if (primary) { e.currentTarget.style.filter = ''; e.currentTarget.style.transform = ''; }
    else { e.currentTarget.style.borderColor = 'var(--border-color)'; e.currentTarget.style.color = 'var(--text-primary)'; e.currentTarget.style.background = 'transparent'; }
  };

  const inner = (
    <>
      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{I && <I />}{label}</span>
      <Icon.ExternalLink />
    </>
  );

  if (href) return <a href={href} target={newTab ? '_blank' : '_self'} rel="noreferrer" style={style} onMouseEnter={enter} onMouseLeave={leave}>{inner}</a>;
  return <button onClick={onClick} style={style} onMouseEnter={enter} onMouseLeave={leave}>{inner}</button>;
}

function TechLogoChip({ item }) {
  const [err, setErr] = React.useState(false);
  const showFallback = item.fallback || err;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 5,
      padding: '4px 8px 4px 5px',
      borderRadius: 4,
      border: '1px solid var(--border-color)',
      background: 'var(--accent-glow)',
      transition: 'border-color 0.15s',
    }}
      onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent-color)'}
      onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border-color)'}
    >
      {showFallback ? (
        <svg width="14" height="14" viewBox="0 0 20 20">
          <rect width="20" height="20" rx="3" fill={item.fallback?.bg || '#333'} />
          <text x="10" y="10" textAnchor="middle" dominantBaseline="central"
            fontSize={item.fallback?.text?.length > 2 ? 6 : 9}
            fontWeight="700" fill={item.fallback?.color || '#fff'}
            fontFamily="monospace">{item.fallback?.text || '?'}</text>
        </svg>
      ) : (
        <img
          src={item.src} width="14" height="14" alt={item.name}
          onError={() => setErr(true)}
          style={{ filter: item.invert ? 'invert(0.85)' : 'none', display: 'block' }}
        />
      )}
      <span style={{
        fontFamily: 'var(--mono)', fontSize: 7.5, letterSpacing: '0.5px',
        color: 'var(--text-muted)', textTransform: 'uppercase',
      }}>{item.name}</span>
    </div>
  );
}

export default function RecruiterPanel({ isOpen, onClose, dark, onToggleTheme }) {
  return (
    <>
      <div className={`recruiter-overlay ${isOpen ? 'active' : ''}`} onClick={onClose} />

      <div className={`recruiter-panel ${isOpen ? 'active' : ''}`}>

        {/* ── Header ── */}
        <div className="recruiter-panel-hdr" style={{ flexDirection: 'column', gap: 0, padding: '18px 20px', alignItems: 'stretch' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontFamily: 'var(--bebas)', fontSize: 22, letterSpacing: '2px', color: 'var(--text-primary)', lineHeight: 1 }}>
                VIKASH GAUTAM
              </div>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 8, letterSpacing: '2px', color: 'var(--accent-color)', marginTop: 3, textTransform: 'uppercase' }}>
                Full Stack Developer · AI/ML · Immediate Joiner
              </div>
            </div>
            <button
              onClick={onClose}
              style={{
                background: 'transparent', border: '1px solid var(--border-color)',
                color: 'var(--text-muted)', width: 30, height: 30, borderRadius: 3,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', transition: 'all 0.2s', flexShrink: 0,
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent-color)'; e.currentTarget.style.color = 'var(--accent-color)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border-color)'; e.currentTarget.style.color = 'var(--text-muted)'; }}
            ><Icon.X /></button>
          </div>

          {/* Live badge */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 10 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--green)', boxShadow: '0 0 6px var(--green)', animation: 'dotP 1.8s ease-in-out infinite', flexShrink: 0 }} />
            <span style={{ fontFamily: 'var(--mono)', fontSize: 8, letterSpacing: '1.5px', color: 'var(--text-muted)', textTransform: 'uppercase' }}>
              Open to work · Nagpur, India · Relocatable
            </span>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="recruiter-panel-body" style={{ gap: '1.4rem' }}>

                    <Divider label="display" />

            {/* ── Dark Space Protocol- first thing they see ── */}
{/* ── Dark Space Protocol teaser ── */}
<div
  onClick={onToggleTheme}
  style={{
    position: 'relative', overflow: 'hidden',
    borderRadius: 6, cursor: 'pointer',
    border: `1px solid ${dark ? 'rgba(212,168,67,0.3)' : 'rgba(30,64,175,0.2)'}`,
    background: dark
      ? 'linear-gradient(135deg, rgba(212,168,67,0.08) 0%, rgba(5,7,12,0.9) 60%)'
      : 'linear-gradient(135deg, #0F172A 0%, #1E293B 60%, #0F172A 100%)',
    padding: '20px 18px',
    boxShadow: dark
      ? '0 0 24px rgba(212,168,67,0.08), inset 0 1px 0 rgba(212,168,67,0.1)'
      : '0 8px 32px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.05)',
  }}
  onMouseEnter={e => {
    e.currentTarget.style.boxShadow = dark
      ? '0 0 32px rgba(212,168,67,0.18), inset 0 1px 0 rgba(212,168,67,0.2)'
      : '0 12px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.08)';
    e.currentTarget.style.borderColor = dark ? 'rgba(212,168,67,0.6)' : 'rgba(99,102,241,0.5)';
  }}
  onMouseLeave={e => {
    e.currentTarget.style.boxShadow = dark
      ? '0 0 24px rgba(212,168,67,0.08), inset 0 1px 0 rgba(212,168,67,0.1)'
      : '0 8px 32px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.05)';
    e.currentTarget.style.borderColor = dark ? 'rgba(212,168,67,0.3)' : 'rgba(30,64,175,0.2)';
  }}
>
  {/* Star field dots */}
  {[
    { top: '12%',  left: '68%', size: 2.5, delay: '0s' },
    { top: '28%',  left: '82%', size: 1.5, delay: '0.5s' },
    { top: '50%',  left: '90%', size: 2,   delay: '1s' },
    { top: '70%',  left: '75%', size: 1.5, delay: '0.3s' },
    { top: '85%',  left: '88%', size: 1,   delay: '1.4s' },
    { top: '20%',  left: '95%', size: 1,   delay: '0.8s' },
    { top: '60%',  left: '60%', size: 1.5, delay: '1.7s' },
  ].map((s, i) => (
    <div key={i} style={{
      position: 'absolute', top: s.top, left: s.left,
      width: s.size, height: s.size, borderRadius: '50%',
      background: dark ? '#D4AF37' : '#818CF8',
      opacity: 0.8,
      animation: `dotP 2s ${s.delay} ease-in-out infinite`,
      pointerEvents: 'none',
    }} />
  ))}

  {/* Glow orb behind text */}
  <div style={{
    position: 'absolute', top: '-20px', right: '-20px',
    width: 120, height: 120, borderRadius: '50%',
    background: dark
      ? 'radial-gradient(circle, rgba(212,168,67,0.15) 0%, transparent 70%)'
      : 'radial-gradient(circle, rgba(99,102,241,0.2) 0%, transparent 70%)',
    pointerEvents: 'none',
  }} />

{/* Label */}
<div style={{
  fontFamily: 'var(--mono)', fontSize: 7.5, letterSpacing: '2.5px',
  color: dark ? 'rgba(212,168,67,0.7)' : 'rgba(129,140,248,0.9)',
  marginBottom: 10, textTransform: 'uppercase',
  display: 'flex', alignItems: 'center', gap: 6,
}}>
  <div style={{
    width: 5, height: 5, borderRadius: '50%',
    background: dark ? '#D4AF37' : '#818CF8',
    animation: 'dotP 1.8s ease-in-out infinite',
  }} />
{dark ? 'dark space protocol · active' : '→ try this- takes 2 seconds'}
</div>

{/* Headline */}
<div style={{
  fontFamily: 'var(--bebas)', letterSpacing: '2px', lineHeight: 1,
  marginBottom: 10, fontSize: 28,
  color: dark ? '#F0EAD6' : '#F8FAFC',
}}>
  {dark ? "YOU'RE IN\nDEEP SPACE" : "WANT TO SEE\nSOMETHING\nCOOL? →"}
</div>

  {/* Description */}
<p style={{
  fontFamily: 'var(--mono)', fontSize: 8, lineHeight: 1.8,
  color: dark ? 'rgba(240,234,214,0.45)' : 'rgba(148,163,184,0.9)',
  margin: '0 0 16px 0', maxWidth: '75%',
}}>
  {dark
    ? 'Parallax star field, shooting meteors & live planetary scroll indicator running behind this panel.'
    : 'Click to unlock dark space mode- a live star field, shooting meteors & a planetary system that reacts to your scroll. Trust me.'}
</p>

  {/* CTA button */}
  <div style={{
    display: 'inline-flex', alignItems: 'center', gap: 10,
    padding: '9px 16px', borderRadius: 3,
    background: dark ? 'rgba(212,168,67,0.12)' : 'rgba(99,102,241,0.9)',
    border: `1px solid ${dark ? 'rgba(212,168,67,0.4)' : 'transparent'}`,
    fontFamily: 'var(--mono)', fontSize: 8.5, fontWeight: 700,
    letterSpacing: '1.5px', textTransform: 'uppercase',
    color: dark ? '#D4AF37' : '#fff',
    transition: 'all 0.2s',
  }}>
    {dark ? <Icon.Sun /> : <Icon.Moon />}
    {dark ? 'Restore Standard View' : 'Launch Dark Space →'}
  </div>
</div>

                    <Divider label="Quick Stats" />


          {/* Quick stats */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {QUICK_STATS.map((s, i) => (
              <div key={i} style={{
                padding: '10px 12px', borderRadius: 4,
                background: 'var(--accent-glow)', border: '1px solid var(--border-color)',
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
              }}>
                <span style={{ fontFamily: 'var(--bebas)', fontSize: 22, color: 'var(--accent-color)', letterSpacing: 1, lineHeight: 1 }}>{s.val}</span>
                <span style={{ fontFamily: 'var(--mono)', fontSize: 7, letterSpacing: '0.5px', color: 'var(--text-muted)', textTransform: 'uppercase', textAlign: 'center' }}>{s.label}</span>
              </div>
            ))}
          </div>

          <Divider label="profile" />

          {/* Credential rows */}
          <div>
            {CREDENTIALS.map((c, i) => (
              <Row key={i} label={c.label} value={c.value} />
            ))}
            <div style={{ paddingTop: 8 }} /> {/* remove last border */}
          </div>

<Divider label="Skills" />

          {/* Tech stack- logo grid, scannable at a glance */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {Object.entries(TECH_STACK).map(([cat, techs]) => (
              <div key={cat}>
                <div style={{
                  fontFamily: 'var(--mono)', fontSize: 7, letterSpacing: '2px',
                  color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: 7,
                }}>{cat}</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {techs.map(t => (
                    <TechLogoChip key={t.name} item={t} />
                  ))}
                </div>
              </div>
            ))}
          </div>

          <Divider label="recognitions" />

          {/* Recognitions */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {[
              'Govt. of India Copyright · Reg. No: L-151429/2024',
              '3 peer-reviewed research papers- AI Forgery Detection · Image Enhancement · Mock Interview System',
              'GATE 2026 DS&AI- AIR 12,757',
              'GATE 2026 CS&IT- Qualified',
              'Sole maintainer- Indian Railways VMS across 4 divisions',
            ].map((item, i, arr) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'flex-start', gap: 8,
                padding: '7px 0',
                borderBottom: i < arr.length - 1 ? '1px solid var(--border-color)' : 'none',
              }}>
                <span style={{ color: 'var(--accent-color)', flexShrink: 0, marginTop: 1 }}><Icon.Award /></span>
                <span style={{ fontFamily: 'var(--mono)', fontSize: 8.5, color: 'var(--text-muted)', lineHeight: 1.6 }}>{item}</span>
              </div>
            ))}
          </div>

          <Divider label="materials" />

          {/* Resume + contacts */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
            <Btn href="https://drive.google.com/file/d/1pK0nLPePrEtZkrpqajLdGeJlG9Khs2Rt/view?usp=drive_link" icon={Icon.File} label="Download Resume (PDF)" primary newTab />
            <Btn href="mailto:gautam7.ven@gmail.com"         icon={Icon.Mail}     label="gautam7.ven@gmail.com"     newTab={false} />
            <Btn href="tel:+919307231784"                    icon={Icon.Phone}    label="+91 93072 31784"           newTab={false} />
            <Btn href="https://linkedin.com/in/vikash2808"  icon={Icon.Linkedin} label="linkedin / vikash2808"     newTab />
            <Btn href="https://github.com/vikash1311"        icon={Icon.Github}   label="github / vikash1311"       newTab />
          </div>



          {/* Theme toggle */}
          {/* <div>
            <Btn onClick={onToggleTheme} icon={dark ? Icon.Sun : Icon.Moon}
              label={dark ? 'Standard View' : 'Dark Space Protocol'} />
            {!dark && (
              <p style={{ fontFamily: 'var(--mono)', fontSize: 7.5, letterSpacing: '0.3px', color: 'var(--text-muted)', marginTop: 8, lineHeight: 1.7 }}>
                Dark mode enables parallax space background, shooting stars, and planetary scroll indicator.
              </p>
            )}
          </div> */}

        </div>
      </div>
    </>
  );
}